import { render, staticRenderFns } from "./CommonPortionStatusBadge.vue?vue&type=template&id=3dc18437&scoped=true&"
import script from "./CommonPortionStatusBadge.vue?vue&type=script&lang=js&"
export * from "./CommonPortionStatusBadge.vue?vue&type=script&lang=js&"
import style0 from "./CommonPortionStatusBadge.vue?vue&type=style&index=0&id=3dc18437&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dc18437",
  null
  
)

export default component.exports